import Vue from 'vue';
import {F_ERR_ENUM} from "../enum/field-error.enum";

Vue.directive('required', {
  bind (el, binding, vnode) {
    const error = `${binding.value || 'field_is_required'}`;

    if (typeof vnode.componentInstance.$data.placeholderSuffix === 'string') {
      vnode.componentInstance.$data.placeholderSuffix = '*';
    }
    if (typeof vnode.componentInstance.setError === 'function') {
      const errorBuilder = (v) => {
        if (v.length > 0) {
          vnode.componentInstance.setError(F_ERR_ENUM.REQUIRED, null);
          return;
        }
        vnode.componentInstance.setError(F_ERR_ENUM.REQUIRED, error);
      };
      vnode.componentInstance.$on('input', errorBuilder);
      vnode.componentInstance.$on('compute-errors', errorBuilder);
    }

  }
});



// WEBPACK FOOTER //
// ./src/directives/required.directive.js